import { Routes } from '@angular/router';
import { Complete } from './components/complete/complete';
import { File } from './components/file/file';

export const routes: Routes = [ 
  { path: '', pathMatch: 'full', redirectTo: 'file' },
  { path: 'file', component: File },
  { path: 'complete', component: Complete },
  { path: '**', redirectTo: 'file' },

];
